<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap recom-write-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>고객 / 코칭 일지</h3>
      </div>
      <div class="body-wrap">
        <div class="write-form">
          <input type="text" placeholder="제목을 작성해 주세요 * " v-model="input.contentTitle" />
        </div>
        <div class="write-form">
          <textarea placeholder="추천 이유를 작성해 주세요 *" v-model="input.contentReasonsRecommendation"></textarea>
        </div>
        <div class="write-form">
          <input type="text" placeholder="추천 영상 링크를 넣어주세요 * " v-model="input.contentVideoUrl" />
          <p>* 유튜브 영상 링크만 넣어주세요</p>
        </div>

        <div class="send-list">
          <h1>받는 사람</h1>
          <div class="all">
            <label> <input type="checkbox" v-model="isAllChk" :value="false" @change="allChk()" /> 전체 선택 </label>
          </div>
          <div class="client">
            <label v-for="(item, index) in user" :key="index">
              <input type="checkbox" :value="item" v-model="item.check" @change="checkboxChange(item.check, item)" />
              {{ item.userName }} <span>{{ item.companyname }} | {{ item.courseName }}</span>
            </label>
            <!-- <label>
                            <input type="checkbox"/> 정수빈 <span>두산중공업 | 임원코칭</span>
                        </label> -->
          </div>
        </div>
        <div class="bnb-btn">
          <button class="active" @click="videoRecom()">영상 추천하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import { EmptyCheck } from "@/utils/validation.js";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "video_write",
  props: {
    isRetake: {
      type: [Number, String],
      default: 0,
    },
    userIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    user: [],
    input: {
      contentTitle: "",
      contentReasonsRecommendation: "",
      contentVideoUrl: "",
      idxTbCoarch: 0,
      requestUserIdList: [],
    },
    isAllChk: false,
    isLoadingPop: false,
  }),
  components: {
    incBack,
    Loading,
  },
  mounted() {
    this.getUserList();
    if (this.isRetake > 0) {
      this.getCoachVideoList();
    }
  },
  methods: {
    getCoachVideoList() {
      this.axios
        .get(`/content/coach/${this.$store.state.userInfo.userIdx}?page=1`)
        .then((res) => {
          if (res.data.success) {
            let videoTemp = res.data.data;
            let index = videoTemp.findIndex((obj) => obj.contentIdx == this.isRetake);
            this.input.contentTitle = videoTemp[index].contentTitle;
            this.input.contentReasonsRecommendation = videoTemp[index].contentReasonsRecommendation;
            this.input.contentVideoUrl = videoTemp[index].contentVideoUrl;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    videoRecom() {
      if (!EmptyCheck(this.input.contentTitle, "제목을")) {
        return false;
      }
      if (!EmptyCheck(this.input.contentReasonsRecommendation, "추천 이유을")) {
        return false;
      }
      if (!EmptyCheck(this.input.contentVideoUrl, "추천 영상 링크")) {
        return false;
      }
      if (!this.input.requestUserIdList.length) {
        alert("받는 사람을 선택해주세요.");
        return false;
      }
      this.input.idxTbCoarch = this.$store.state.userInfo.userIdx;
      let params = this.input;
      this.isLoadingPop = true;
      this.axios
        .post("/content/coarch", params)
        .then((res) => {
          if (res.data.success) {
            this.isLoadingPop = false;
            alert("영상이 추천 되었습니다.");
            this.$router.go(-1);
          } else {
            alert(res.data.message);
            this.isLoadingPop = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    allChk() {
      this.input.requestUserIdList = [];
      if (this.isAllChk) {
        for (let i = 0; i < this.user.length; i++) {
          this.user[i].check = true;
          this.input.requestUserIdList.push(this.user[i].userIdx);
        }
      } else {
        for (let i = 0; i < this.user.length; i++) {
          this.user[i].check = false;
        }
        this.input.requestUserIdList = [];
      }
    },
    checkboxChange(check, item) {
      if (check) {
        this.input.requestUserIdList.push(item.userIdx);
      } else {
        let index = this.input.requestUserIdList.findIndex((obj) => obj == item.userIdx);
        this.input.requestUserIdList.splice(index, 1);
      }
      if (this.input.requestUserIdList.length < this.user.length) {
        this.isAllChk = false;
      } else {
        this.isAllChk = true;
      }
    },
    getUserList() {
      this.axios
        .get(`/content/coach/${this.$store.state.userInfo.idxTbCoarch}/users`)
        .then((res) => {
          if (res.data.success) {
            this.user = res.data.data.map((item) => {
              return { ...item, check: false };
            });

            if (this.userIdx != 0) {
              const number = this.user.findIndex((aItem) => aItem.userIdx == this.userIdx);
              if (number != -1) {
                this.user[number].check = true;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
